import { render, staticRenderFns } from "./showPubs.vue?vue&type=template&id=0b48777c&scoped=true&"
import script from "./showPubs.vue?vue&type=script&lang=js&"
export * from "./showPubs.vue?vue&type=script&lang=js&"
import style0 from "./showPubs.vue?vue&type=style&index=0&id=0b48777c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b48777c",
  null
  
)

export default component.exports